import React, { useState } from "react";
import Navbar from "./Components/Header/Navbar";
import ScrollToTop from "./ScrollToTop";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home/Home";
import Footer from "./Components/Footer/Footer";
import PrivacyPolicy from "./Pages/Privacy Policy/PrivacyPolicy";
import TermsAndConditions from "./Pages/Terms and conditions/TermsAndConditions";

function App() {

  const [isBackgroundBlurred, setIsBackgroundBlurred] = useState(false);

  return (
    <div>
      <Navbar setBackgroundBlur={setIsBackgroundBlurred} />
      <div id="background" className={`xl:pt-12 max-sm:pt-12 ${isBackgroundBlurred ? '' : ''}`}>
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={<Home />}
          />
          <Route
            path="/privacy-policy"
            element={<PrivacyPolicy />}
          />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route
            path="*"
            element={<Navigate to="/" />}
          />
        </Routes>
        <Footer />
      </div>
    </div>
  );
}

export default App;



// import { useEffect, useRef, useState } from "react";
// import "tailwindcss/tailwind.css";

// export default function ScrollVideo() {
//   const videoRef = useRef(null);
//   const containerRef = useRef(null);
//   const [isFixed, setIsFixed] = useState(true);
//   let scrollTimeout = useRef(null);
  
//   useEffect(() => {
//     const handleScroll = () => {
//       if (!videoRef.current || !containerRef.current) return;
//       const video = videoRef.current;
//       const container = containerRef.current;
      
//       const rect = container.getBoundingClientRect();
//       const windowHeight = window.innerHeight;
      
//       // Play video only while scrolling
//       if (rect.top <= 0 && Math.abs(rect.top) <= container.offsetHeight - windowHeight) {
//         setIsFixed(true);
//         const scrollProgress = Math.min(1, Math.abs(rect.top) / (container.offsetHeight - windowHeight));
//         video.currentTime = scrollProgress * video.duration;
//         if (video.paused) video.play();
        
//         // Clear previous timeout to prevent pausing too soon
//         if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
        
//         // Pause the video if no scrolling is detected after 200ms
//         scrollTimeout.current = setTimeout(() => {
//           if (!video.paused) video.pause();
//         }, 100);
//       } else {
//         setIsFixed(false);
//         if (!video.paused) video.pause();
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//       if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
//     };
//   }, []);

//   return (
//     <div className="relative w-full">
//       {/* Top Content */}
//       <section className="h-screen bg-gray-900 text-white flex items-center justify-center text-3xl font-bold">
//         Welcome to Our Experience
//       </section>

//       {/* Video Section */}
//       <div ref={containerRef} className="relative h-[300vh]">
//         <div className={`w-full h-screen flex items-center justify-center ${isFixed ? "fixed top-0 left-0" : "relative"}`}>
//           <video ref={videoRef} className="w-full h-full object-cover" muted playsInline>
//             <source src="https://mh-cognition.blr1.cdn.digitaloceanspaces.com/Enterprise/VR%20Classroom.mp4" type="video/mp4" />
//           </video>
//         </div>
//       </div>

//       {/* Bottom Content */}
//       <section className="h-screen bg-gray-800 text-white flex items-center justify-center text-3xl font-bold">
//         Thank You for Watching
//       </section>
//     </div>
//   );
// }